export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceName: "アイラ地域サポート",
      serviceFunctions: [
        {
          functionId: 5,
          serviceFunctionUuid: "servicefunction005",
          functionMstUuid: "functionmst005",
          functionName: "ビデオチャット機能",
          deliveryType: "video_chat"
        },
        {
          functionId: 4,
          serviceFunctionUuid: "servicefunction004",
          functionMstUuid: "functionmst004",
          functionName: "警戒レベル告知機能",
          deliveryType: "keikai"
        },
        {
          functionId: 3,
          serviceFunctionUuid: "servicefunction003",
          functionMstUuid: "functionmst003",
          functionName: "スマホ連携機能",
          deliveryType: "family_info"
        },
        {
          functionId: 2,
          serviceFunctionUuid: "servicefunction002",
          functionMstUuid: "functionmst002",
          functionName: "御用聞き機能",
          deliveryType: "ordertake"
        },
        {
          functionId: 1,
          serviceFunctionUuid: "servicefunction001",
          functionMstUuid: "functionmst001",
          functionName: "見守り機能",
          deliveryType: "follow"
        }
      ]
    }
  }
}